/**
 * FMT の種類（月次経理と決算）ごとの違い。
 *
 * 月次経理の型と決算タスクFMT は、列も画面も同じ作りで、違うのは保存先・起こすタスクの
 * 種別・画面の言葉だけ。画面を 2 つ書き分けると片方だけ直し漏れるので、違いをここに
 * 集めて同じ画面へ渡す。
 *
 * @graph-stack ado-task
 * @graph-domain Finance
 * @graph-business FMT の種類（月次経理・決算）ごとの保存先・タスク種別・画面の言葉を定義する
 * @graph-connects none
 */

/** FMT の種類ごとの設定 */
export interface FmtVariant {
  /** 画面の見出しの上に出すまとまりの名前（サイドバーの見出しと同じ） */
  section: string;
  /** 型の呼び名（空のときの案内などに使う） */
  name: string;
  /** FMT 画面の見出しの下に出す説明 */
  description: string;
  /** API のパス */
  apiPath: string;
  /** 起こすタスクの種別 */
  kind: string;
  /** 起こすタスクの ID の頭。同じ月を二重に起こさない判定にも使う */
  taskIdPrefix: string;
  /** 対象の月を選ぶところの言葉 */
  periodLabel: string;
  /** 対象の月の後ろに付ける言葉（「2026年9月分」の「分」） */
  periodSuffix: string;
}

/** 月次経理の型 */
/** @graph-connects none */
export const MONTHLY_FMT: FmtVariant = {
  section: '月次経理',
  name: '月次経理の型',
  description: '毎月の経理作業の型。行を押すと編集、右端の × で削除できます',
  apiPath: '/monthly-fmt-items',
  kind: '月次経理',
  taskIdPrefix: 'fmt',
  periodLabel: '何月分',
  periodSuffix: '分',
};

/**
 * 決算タスクFMT。対象は決算月（四半期末の月）で、作業は翌月に行う（月次と同じ数え方）
 * @graph-connects none
 */
export const CLOSING_FMT: FmtVariant = {
  section: '決算',
  name: '決算タスクFMT',
  description:
    '四半期・年次の決算作業の型。決算月（四半期末の月）を選ぶと、翌月の営業日でタスクを作ります',
  apiPath: '/closing-fmt-items',
  kind: '決算',
  taskIdPrefix: 'closing',
  periodLabel: '決算月',
  periodSuffix: '決算分',
};
